import { useQuery } from "@tanstack/react-query";
import { useSessionJWT } from "utils";

import { getAccountKYCStatus } from "../pii";

/**
 * Check an end-user's current KYC status
 * @name useAccountKYCStatus
 * @author magnus
 * @param {String} kycId
 */
export default function useAccountKYCStatus() {
  const { sessionJWT } = useSessionJWT();

  return useQuery({
    queryKey: ["kyc", "details", "account"],
    queryFn: () => getAccountKYCStatus(sessionJWT)
  });
}
